import { show } from "@ebay/nice-modal-react";
import { isApplicationReadySelector, LocalStorageKeys } from "@repo/logic";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AMLRedirect } from "../AML";
import { getBankIdAuthorizationUri, type AMLActionInfo } from "../AML/identification";
import { useSmartAction } from "../Contract/SmartAction/context";

export const useRedirectToContributionWithQuestionare = (): void => {
    const { action, clearAction } = useSmartAction();
    const isAppReady = useSelector(isApplicationReadySelector);

    // vyvolání modalu při redirectu z bankid aplikace
    useEffect(() => {
        if (action?.type === "ContributionWithQuestionare" && isAppReady) {
            const aMLActionInfo = action.context?.AMLActionInfo as AMLActionInfo;
            show("Nicemodal-ChangePensionContributionStepperModal", {
                additionalContentProps: {
                    bankIdcompleted: action.context?.success as boolean,
                    bankIdErrorMessage: action.context?.errorMessage as string,
                    contractId: aMLActionInfo.contractId,
                    contractType: aMLActionInfo.contractType,
                    bankIdAuthorizationUri: getBankIdAuthorizationUri(),
                    beforeBankIdAuthorizationAction: () => {
                        localStorage.setItem(
                            LocalStorageKeys.BANK_ID_LAST_ACTION,
                            JSON.stringify({
                                redirect: AMLRedirect.ContributionWithQuestionare,
                                contractId: aMLActionInfo.contractId,
                                contractType: aMLActionInfo.contractType,
                            }),
                        );
                    },
                },
            });
            clearAction();
        }
    }, [action, action?.context?.contractId, action?.context?.contractType, action?.type, clearAction, isAppReady]);
};
